import React, { useState, useEffect } from "react";
import moment from "moment";
import { connect } from "react-redux";
import AssignPCP from "../../../AssignPCP";
import Popup from "reactjs-popup";
import {
  setStateParams,
  getPcpList,
} from "../../../../Redux/Actions/webAppActions";
import { Text } from "react-internationalization";
import Button from "../../../../Utils/GenericUI/Button";
import { useSelector } from "react-redux";
import PcpInputs from "../PcpInputs";
const Step2 = (props) => {
  const [state, setState] = useState({
    stateFlag: false,
    pcpShown: props.pcpSelected.pcpName ? props.pcpSelected.pcpName : "",
    clinicShown:
      props.pcpSelected.pcpName && props.pcpSelected.pcpName !== "---Select---"
        ? props.physiciansData.length > 1
          ? props.physiciansData.filter(
              (data1) => data1.doctorName === props.pcpSelected.pcpName
            )[0] != undefined
            ? props.physiciansData.filter(
                (data1) => data1.doctorName === props.pcpSelected.pcpName
              )[0].clinicName
            : ""
          : ""
        : props.preEnrollInfo && props.preEnrollInfo.pcpDetails
        ? props.preEnrollInfo.pcpDetails.name
        : "",
  });
  const clickedSaveNextIds = useSelector(
    (state1) => state1.webApp.clickedSaveNextIds
  );
  // SONARconst setFlag = () => {
  //   setState({ ...state, stateFlag: true });
  // };
  useEffect(() => {
    const {
      //data,
      permanentAddrStreet,
      permanentCity,
      permanentZip,
    } = props;
    let fullAddr = data.permanentAddrStreet ? data.permanentAddrStreet : "";
    let zip = data.permanentZip;
    if (props.product != "PDP" && props.productName !== "Medicare Supplement") {
      if (
        data.permanentAddrStreet !== "" &&
        data.permanentCity !== "" &&
        zip !== "" &&
        props.deeplink === false
      ) {
        if (
          data.permanentAddrStreet !== permanentAddrStreet ||
          data.permanentCity !== permanentCity ||
          zip !== permanentZip
        ) {
          props.getPcpList({
            address: data.permanentAddrStreet,
            city: data.permanentCity,
            zipCode: zip,
            distance: "100",
            customerId: props?.customerId,
            planYear: props.year,
            productId: props.productId,
          });
          props.setStateParams("permanentAddrStreet", data.permanentAddrStreet);
          props.setStateParams("permanentCity", data.permanentCity);
          props.setStateParams("permanentZip", zip);
          // setState({ formerEmpOfSharp: !this.state.formerEmpOfSharp });
        }
      }
      if (
        data.permanentAddrStreet !== "" &&
        data.permanentCity !== "" &&
        props.dpzipCode !== "" &&
        props.deeplink === true
      ) {
        if (
          data.permanentAddrStreet !== permanentAddrStreet ||
          data.permanentCity !== permanentCity ||
          props.dpzipCode !== permanentZip
        ) {
          props.getPcpList({
            address: data.permanentAddrStreet,
            city: data.permanentCity,
            zipCode: props.dpzipCode,
            distance: "100",
            customerId: props?.customerId,
            planYear: props.year,
            productId: props.productId,
          });
          props.setStateParams("permanentAddrStreet", data.permanentAddrStreet);
          props.setStateParams("permanentCity", data.permanentCity);
          props.setStateParams("permanentZip", props.dpzipCode);
          // this.setState({ formerEmpOfSharp: !this.state.formerEmpOfSharp });
        }
      }
      // else {
      if (
        fullAddr === "" ||
        fullAddr === undefined ||
        data.permanentCity === ""
      ) {
        //   if(data.permanentAddrStreet === "" ||
        // data.permanentCity === ""){
        setState({ ...state, flag: true });
        props.setSnackBar(
          props.lang === "es"
            ? "Complete la dirección permanente en la sección 1 para obtener el PCP y el nombre de la clínica."
            : "Please fill permanent address in section 1 to get PCP's and Clinic Name."
        );
      }
    }
    if (props.preEnrollInfo.pcpName) {
      setState({
        ...state,
        pcpShown: props.preEnrollInfo.pcpName,
        clinicShown: props.preEnrollInfo.pcpDetails.name
          ? props.preEnrollInfo.pcpDetails.name
          : "",
      });
    }
  }, []);
  useEffect(() => {
    const clinicName =
      props.pcpSelected.pcpName && props.pcpSelected.pcpName !== "---Select---"
        ? props.physiciansData.length > 1
          ? props.physiciansData.filter(
              (data1) => data1.doctorName === props.pcpSelected.pcpName
            )[0] != undefined
            ? props.physiciansData.filter(
                (data1) => data1.doctorName === props.pcpSelected.pcpName
              )[0].clinicName
            : ""
          : ""
        : props.preEnrollInfo && props.preEnrollInfo.pcpDetails
        ? props.preEnrollInfo.pcpDetails.name
        : "";

    if (props.pcpSelected.pcpName !== state.pcpShown) {
      setState({
        ...state,
        pcpShown: props.pcpSelected.pcpName,
        clinicShown: clinicName,
      });
    }
  }, [props]);
  const { data } = props;
  return (
    <React.Fragment>
      {/* <div class="tab-content tab-contentSharp"> */}
      <div
        id="step2"
        class={
          props.preEnrollInfo?.appStatus != "READY" &&
          props.preEnrollInfo?.appStatus != "SUBMITTED"
            ? "container tab-pane active"
            : "container tab-pane active disable-form"
        }
      >
        <h3 class="tab-heading">STEP 2: MEDICARE INFORMATION</h3>
        <p class="medicare-note">
          Please Provide Your Medicare Insurance Information:
          <br />
          <strong>Note: </strong> You must have Medicare Part A and Part B to
          join a Medicare Advantage plan.
        </p>

        <h4 class="sub-heading">
          <strong>
            A. Please fill in these blanks so they match your red, white and
            blue Medicare card.
          </strong>
        </h4>
        <div class="form-group row">
          <div class="col-md-6">
            <p>
              <label for="medicareNumber" class="control-label">
                Medicare Number*
              </label>
              <input
                autoComplete="off"
                spellcheck="false"
                aria-autocomplete="both"
                aria-haspopup="false"
                type="text"
                placeholder="XXXXXXXXXXX"
                //pattern="/[a-zA-Z0-9]{10,11}/"
                name="medicareNumber"
                id="medicareNumber"
                minLength="11"
                maxlength="13"
                class={
                  clickedSaveNextIds.includes("next2")
                    ? data.medicareNumber?.length < 11
                      ? "error-input"
                      : "form-control"
                    : "form-control"
                }
                value={data.medicareNumber}
                onChange={props.handleChange}
                required=""
              />
            </p>
            <p>
              {props.agentLogin === true && (
                <Button
                  className="btn btn-secondary-enroll chkbutton "
                  id="checkEligibity"
                  onButtonClick={props.checkEligibility}
                  buttonLabel={"Check Eligibility"}
                />
              )}
            </p>
            <p>
              <label class="control-label" for="partAEffDate">
                Hospital (Part A) Effective Date*
              </label>
              <input
                autoComplete="off"
                spellcheck="false"
                aria-autocomplete="both"
                aria-haspopup="false"
                placeholder="MM/DD/YYYY "
                maxLength="10"
                class={
                  clickedSaveNextIds.includes("next2") &&
                  (data.partAEffDate === "" ||
                    !moment(data.partAEffDate, "MM/DD/YYYY", true).isValid())
                    ? "error-input"
                    : "form-control"
                }
                name="partAEffDate"
                id="partAEffDate"
                value={data.partAEffDate}
                onChange={props.handleDate}
                onClick={(e) => props.handleDates("partAEffDate")}
                required=""
              />
            </p>

            <p>
              <label class="control-label" for="partBEffDate">
                Medical (Part B) Effective Date*
              </label>
              <input
                autoComplete="off"
                spellcheck="false"
                aria-autocomplete="both"
                aria-haspopup="false"
                placeholder="MM/DD/YYYY"
                maxLength="10"
                class={
                  clickedSaveNextIds.includes("next2") &&
                  (data.partBEffDate === "" ||
                    !moment(data.partBEffDate, "MM/DD/YYYY", true).isValid())
                    ? "error-input"
                    : "form-control"
                }
                name="partBEffDate"
                id="partBEffDate"
                value={data.partBEffDate}
                onChange={props.handleDate}
                onClick={(e) => props.handleDates("partBEffDate")}
                required=""
              />
            </p>
          </div>
          <div class="col-md-6">
            <img
              src={require("../../../../assests/images/Medicardlogoshp_New.png")}
              alt=""
              class="width100per"
            />
          </div>
        </div>

        <h4 class="sub-heading">
          <strong>B. Paying Your Plan Premium</strong>
        </h4>
        <div class="form-group">
          <p class="text-align-justify">
            <strong>
              If we determine that you owe a late enrollment penalty (or if you
              currently have a late enrollment penalty), we need to know your
              payment preference. You can pay by mail, "Electronic Funds
              Transfer (EFT)", or "credit card" each month. You can also choose
              to pay your premium by automatic deduction from your Social
              Security or Railroad Retirement Board (RRB) benefit check each
              month.
            </strong>
          </p>

          <p class="text-align-justify">
            <strong>
              You can pay your monthly plan premium (including any late
              enrollment penalty that you currently have or may owe) by mail,
              "Electronic Funds Transfer (EFT)" or "credit card" each month. You
              can also choose to pay your premium by automatic deduction from
              your Social Security or RRB.
            </strong>
          </p>

          <p class="text-align-justify">
            <strong>
              If you are assessed a Part D-Income Related Monthly Adjustment
              Amount(Part D-IRMAA), you will be notified by the Social Security
              Administration. You will be responsible for paying this extra
              amount in addition to your plan premium. You will either have the
              amount with held from your Social Security benefit check or be
              billed directly by Medicare or the RRB. DO NOT pay Sharp Health
              Plan the Part D-IRMAA.
            </strong>
          </p>

          <p class="medicare-note text-align-justify">
            People with limited incomes may qualify for Extra Help to pay for
            their prescription drug costs. If eligible, Medicare could pay for
            75% or more of your drug costs including monthly prescription drug
            premiums, annual deductibles and coinsurance. Additionally, those
            who qualify will not be subject to the coverage gap or a late
            enrollment penalty. Many people are eligible for these savings and
            don't even know it. For more information about this Extra Help,
            contact your local Social Security office or call Social Security at
            1-800-772-1213.TTY/TDD users should call 1-800-325-0778.You can also
            apply for Extra Help online at
            www.socialsecurity.gov/prescriptionhelp.
            <br />
            <br />
            If you qualify for Extra Help with your Medicare prescription drug
            coverage costs, Medicare will pay all or part of your plan premium
            If Medicare pays only a portion of this premium, we will bill you
            for the amount that Medicare doesn't cover.
          </p>

          <p>
            <strong>Please select a premium payment option:</strong>
          </p>

          <div class="radio radio-tab">
            <div class="custom-control custom-radio mt-3">
              <input
                autoComplete="off"
                spellcheck="false"
                aria-autocomplete="both"
                aria-haspopup="false"
                type="radio"
                name="premiumType"
                id="getABill"
                class="custom-control-input"
                value="D"
                checked={data.premiumType === "D"}
                onChange={props.handleChange}
              />
              <label for="getABill" class="radio-inline custom-control-label">
                <strong>
                  Get a bill (if a payment applies, you will be able to pay by
                  check or credit card monthly)
                </strong>
              </label>
            </div>

            <div class="custom-control custom-radio mt-3">
              <input
                autoComplete="off"
                spellcheck="false"
                aria-autocomplete="both"
                aria-haspopup="false"
                type="radio"
                name="premiumType"
                class="custom-control-input"
                id="electronicFunds"
                value="R"
                checked={data.premiumType === "R"}
                onChange={props.handleChange}
              />
              <label
                for="electronicFunds"
                class="radio-inline custom-control-label"
              >
                <strong>
                  Electronic funds transfer (EFT) from your bank account on the
                  1st of each month. If the 1st of the month falls on a weekend
                  or bank holiday, your draft will occur on the next banking
                  day.
                </strong>
              </label>
            </div>

            <div class="form-group row ml-3 mt-3">
              <div class="col-md-6">
                <p>
                  <label for="acctholdername" class="control-label">
                    Account holder name:
                  </label>
                  <input
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                    type="text"
                    class="form-control"
                    id="acctholdername"
                    name="acctholdername"
                    value={data.acctholdername}
                    onChange={props.handleChange}
                  />
                </p>

                <fieldset class="radio radio-tab">
                  <legend class="control-label">Account type:</legend>
                  <div class="custom-control custom-radio custom-control-inline">
                    <input
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                      type="radio"
                      name="acctType"
                      id="checking"
                      value="C"
                      class="custom-control-input"
                      checked={data.acctType === "C"}
                      onChange={props.handleChange}
                    />
                    <label
                      for="checking"
                      class="radio-inline custom-control-label"
                    >
                      Checking
                    </label>
                  </div>
                  <div class="custom-control custom-radio custom-control-inline">
                    <input
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                      type="radio"
                      name="acctType"
                      id="saving"
                      value="S"
                      class="custom-control-input"
                      checked={data.acctType === "S"}
                      onChange={props.handleChange}
                    />
                    <label
                      for="saving"
                      class="radio-inline custom-control-label"
                    >
                      Saving
                    </label>
                  </div>
                </fieldset>
              </div>
              <div class="col-md-6">
                <p>
                  <label for="bankname" class="control-label">
                    Bank name:
                  </label>
                  <input
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                    type="text"
                    class="form-control"
                    id="bankname"
                    name="bankname"
                    value={data.bankname}
                    onChange={props.handleChange}
                  />
                </p>

                <p>
                  <label for="routingNumber" class="control-label">
                    Bank routing number:
                  </label>
                  <input
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                    type="text"
                    class="form-control"
                    id="routingNumber"
                    name="routingNumber"
                    value={data.routingNumber}
                    onChange={props.handleNumberChange}
                    placeholder="Enter 9-digit routing number"
                    maxlength="9"
                  />
                </p>

                <p>
                  <label for="accountNumber" class="control-label">
                    Bank account number:
                  </label>
                  <input
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                    type="text"
                    pattern="[0-9]*"
                    class="form-control"
                    id="accountNumber"
                    name="accountNumber"
                    value={data.accountNumber}
                    onChange={props.handleNumberChange}
                    placeholder="Enter a numeric a/c number"
                    maxlength="14"
                  />
                </p>
              </div>
            </div>
            <React.Fragment>
              <div class="custom-control custom-radio mt-3">
                <input
                  autoComplete="off"
                  spellcheck="false"
                  aria-autocomplete="both"
                  aria-haspopup="false"
                  type="radio"
                  name="premiumType"
                  id="automaticDeduction"
                  class="custom-control-input"
                  value="S"
                  checked={data.premiumType === "S"}
                  onChange={props.handleChange}
                />
                <label
                  for="automaticDeduction"
                  class="radio-inline custom-control-label"
                >
                  <strong>
                    Automatic Deduction from your monthly Social Security or
                    Railroad Retirement Board (RRB) benefit check.
                  </strong>
                </label>
              </div>

              <fieldset class="radio radio-tab ml-3 mt-3">
                <legend>I receive monthly benefits from:</legend>
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                    type="radio"
                    name="monthlybf"
                    id="socialSecurity"
                    class="custom-control-input"
                    value="SS"
                    checked={data.monthlybf === "SS"}
                    onChange={props.handleChange}
                  />
                  <label
                    for="socialSecurity"
                    class="radio-inline custom-control-label"
                  >
                    Social Security
                  </label>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                    type="radio"
                    name="monthlybf"
                    id="rrb"
                    class="custom-control-input"
                    value="RRB"
                    checked={data.monthlybf === "RRB"}
                    onChange={props.handleChange}
                  />
                  <label for="rrb" class="radio-inline custom-control-label">
                    RRB
                  </label>
                </div>
              </fieldset>

              <p class="ml-3 mt-3">
                <strong>
                  (The Social Security deduction may take two or more months to
                  begin after Social Security or RRB approves the deduction. In
                  most cases, if Social Security or RRB accepts your request for
                  automatic deduction, the first deduction from your Social
                  Security or RRB benefit check will include all premiums due
                  from your enrollment effective date up to the point
                  withholding begins. If Social Security or RRB does not approve
                  your request for automatic deduction, we will send you a paper
                  bill for your monthly premiums.)
                </strong>
              </p>
            </React.Fragment>
          </div>
        </div>

        <h4 class="sub-heading">
          <strong>C. Please read and answer these important questions</strong>
        </h4>
        <div class="form-group">
          <ol>
            <li>
              <fieldset class="radio radio-tab ml-3 mt-3">
                <legend style={{ marginTop: "-2.5rem" }}>
                  Do you have End Stage Renal Disease (ESRD)?*
                </legend>
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                    type="radio"
                    name="esrdInd"
                    id="c_q1_Y"
                    class="custom-control-input"
                    value="Y"
                    checked={data.esrdInd === "Y"}
                    onChange={props.handleChange}
                  />
                  <label for="c_q1_Y" class="radio-inline custom-control-label">
                    Yes
                  </label>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                    type="radio"
                    name="esrdInd"
                    id="c_q1_no"
                    class="custom-control-input"
                    value="N"
                    checked={data.esrdInd === "N"}
                    onChange={props.handleChange}
                  />
                  <label
                    for="c_q1_no"
                    class="radio-inline custom-control-label"
                  >
                    No
                  </label>
                </div>
                {data.esrdInd === "Y" ? (
                  <div>
                    <legend>
                      Have you had a successful kidney transplant and/or you
                      don't need regular dialysis any more?*
                    </legend>
                    If yes, a Licensed Sales Representative may need to contact
                    you to obtain additional information.
                    <br></br>
                    <div class="custom-control custom-radio custom-control-inline">
                      <input
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                        type="radio"
                        name="esrdcontact"
                        id="esrdcontact_Y"
                        class="custom-control-input"
                        value="Y"
                        checked={data.esrdcontact === "Y"}
                        onChange={props.handleChange}
                      />
                      <label
                        for="esrdcontact_Y"
                        class="radio-inline custom-control-label"
                      >
                        Yes
                      </label>
                    </div>
                    <div class="custom-control custom-radio custom-control-inline">
                      <input
                        autoComplete="off"
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                        type="radio"
                        name="esrdcontact"
                        id="esrdcontact_no"
                        class="custom-control-input"
                        value="N"
                        checked={data.esrdcontact === "N"}
                        onChange={props.handleChange}
                      />
                      <label
                        for="esrdcontact_no"
                        class="radio-inline custom-control-label"
                      >
                        No
                      </label>
                    </div>
                  </div>
                ) : null}
              </fieldset>
            </li>
            <li>
              <fieldset class="radio radio-tab ml-3 mt-3" id="c_qns2">
                <legend style={{ marginTop: "-2.5rem" }}>
                  Some individuals may have other drug coverage, including other
                  private insurance, TRICARE, Federal employee health benefits
                  coverage, VA benefits, or State pharmaceutical assistance
                  programs. Will you have other prescription drug coverage in
                  addition to Sharp Health Plan?*
                </legend>
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                    type="radio"
                    name="vaBenefits"
                    id="c_q2_Y"
                    class="custom-control-input"
                    value="Y"
                    checked={data.vaBenefits === "Y"}
                    onChange={props.handleChange}
                  />
                  <label for="c_q2_Y" class="radio-inline custom-control-label">
                    Yes
                  </label>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                    type="radio"
                    name="vaBenefits"
                    id="c_q2_no"
                    class="custom-control-input"
                    value="N"
                    checked={data.vaBenefits === "N"}
                    onChange={props.handleChange}
                  />
                  <label
                    for="c_q2_no"
                    class="radio-inline custom-control-label"
                  >
                    No
                  </label>
                </div>

                {data.vaBenefits === "Y" ? (
                  <div id="c_q2_fields">
                    <div class="row mt-3 ml-1">
                      <div class="col-md-4">
                        <label for="nameOfCov" class="control-label">
                          Name of other coverage*
                        </label>
                        <input
                          autoComplete="off"
                          spellcheck="false"
                          aria-autocomplete="both"
                          aria-haspopup="false"
                          type="text"
                          class={
                            clickedSaveNextIds.includes("next2") &&
                            data.nameOfCov === ""
                              ? "error-input"
                              : "form-control"
                          }
                          id="nameOfCov"
                          name="nameOfCov"
                          value={data.nameOfCov}
                          onChange={props.handleChange}
                        />
                      </div>
                      <div class="col-md-4">
                        <label for="idOfCov" class="control-label">
                          ID# of this coverage*
                        </label>
                        <input
                          autoComplete="off"
                          spellcheck="false"
                          aria-autocomplete="both"
                          aria-haspopup="false"
                          type="text"
                          class={
                            clickedSaveNextIds.includes("next2") &&
                            data.idOfCov === ""
                              ? "error-input"
                              : "form-control"
                          }
                          id="idOfCov"
                          name="idOfCov"
                          value={data.idOfCov}
                          onChange={props.handleChange}
                        />
                      </div>
                      <div class="col-md-4">
                        <label for="groupOfCov" class="control-label">
                          Group# for this coverage*
                        </label>
                        <input
                          autoComplete="off"
                          spellcheck="false"
                          aria-autocomplete="both"
                          aria-haspopup="false"
                          type="text"
                          class={
                            clickedSaveNextIds.includes("next2") &&
                            data.groupOfCov === ""
                              ? "error-input"
                              : "form-control"
                          }
                          id="groupOfCov"
                          name="groupOfCov"
                          value={data.groupOfCov}
                          onChange={props.handleChange}
                        />
                      </div>
                    </div>
                  </div>
                ) : null}
              </fieldset>
            </li>
            <li>
              <fieldset class="radio radio-tab ml-3 mt-3" id="c_qns3">
                <legend style={{ marginTop: "-2.5rem" }}>
                  Are you enrolled in Medi-Cal (Medicaid)?*
                </legend>
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                    type="radio"
                    name="medicaidprg"
                    id="c_q3_Y"
                    class="custom-control-input"
                    value="Y"
                    checked={data.medicaidprg === "Y"}
                    onChange={props.handleChange}
                  />
                  <label for="c_q3_Y" class="radio-inline custom-control-label">
                    Yes
                  </label>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                    type="radio"
                    name="medicaidprg"
                    id="c_q3_no"
                    class="custom-control-input"
                    value="N"
                    checked={data.medicaidprg === "N"}
                    onChange={props.handleChange}
                  />
                  <label
                    for="c_q3_no"
                    class="radio-inline custom-control-label"
                  >
                    No
                  </label>
                </div>

                {data.medicaidprg === "Y" ? (
                  <div id="c_q3_fields">
                    <div class="row mt-3 ml-1">
                      <div class="col-md-12">
                        <label for="medicaidNbr" class="control-label">
                          Please provide your Medi-Cal number*
                        </label>
                        <input
                          autoComplete="off"
                          spellcheck="false"
                          aria-autocomplete="both"
                          aria-haspopup="false"
                          type="text"
                          class={
                            clickedSaveNextIds.includes("next2") &&
                            data.medicaidNbr === ""
                              ? "error-input"
                              : "form-control"
                          }
                          id="medicaidNbr"
                          name="medicaidNbr"
                          value={data.medicaidNbr}
                          onChange={props.handleChange}
                        />
                      </div>
                    </div>
                  </div>
                ) : null}
              </fieldset>
            </li>
            <li>
              <fieldset class="radio radio-tab ml-3 mt-3" id="c_qns4">
                <legend style={{ marginTop: "-2.5rem" }}>
                  Are you a resident in a long-term care facility, such as a
                  nursing home?*
                </legend>
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                    type="radio"
                    name="ltcInd"
                    id="c_q4_Y"
                    class="custom-control-input"
                    value="Y"
                    checked={data.ltcInd === "Y"}
                    onChange={props.handleChange}
                  />
                  <label for="c_q4_Y" class="radio-inline custom-control-label">
                    Yes
                  </label>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                    type="radio"
                    name="ltcInd"
                    id="c_q4_no"
                    class="custom-control-input"
                    value="N"
                    checked={data.ltcInd === "N"}
                    onChange={props.handleChange}
                  />
                  <label
                    for="c_q4_no"
                    class="radio-inline custom-control-label"
                  >
                    No
                  </label>
                </div>

                {data.ltcInd === "Y" ? (
                  <div id="c_q4_fields">
                    <div class="row mt-3 ml-1">
                      <div class="col-md-7">
                        <label for="nameOfInstitution" class="control-label">
                          Name of Institution*:
                        </label>
                        <input
                          autoComplete="off"
                          spellcheck="false"
                          aria-autocomplete="both"
                          aria-haspopup="false"
                          type="text"
                          class={
                            clickedSaveNextIds.includes("next2") &&
                            data.nameOfInstitution === ""
                              ? "error-input"
                              : "form-control"
                          }
                          id="nameOfInstitution"
                          name="nameOfInstitution"
                          value={data.nameOfInstitution}
                          onChange={props.handleChange}
                          required=""
                        />
                      </div>
                      {/* <div class="col-md-5">
                          <label for="phoneOfInst" class="control-label">
                            Phone Number of Institution*:
                          </label>
                          <input autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                            type="text"
                            class={
                              data.phoneOfInst === ""
                                ? "error-input"
                                : "form-control"
                            }
                            id="phoneOfInst"
                            name="phoneOfInst"
                            value={data.phoneOfInst}
                            onChange={props.handleChange}
                            placeholder="(   )   -"
                            maxlength="14"
                          />
                        </div> */}
                    </div>
                    <div class="row mt-3 ml-1">
                      <div class="col-md-12">
                        <label for="addrOfInstitution" class="control-label">
                          Address of Institution (number and street)*
                        </label>
                        <input
                          autoComplete="off"
                          spellcheck="false"
                          aria-autocomplete="both"
                          aria-haspopup="false"
                          type="text"
                          class={
                            clickedSaveNextIds.includes("next2") &&
                            data.addrOfInstitution === ""
                              ? "error-input"
                              : "form-control"
                          }
                          id="addrOfInstitution"
                          name="addrOfInstitution"
                          value={data.addrOfInstitution}
                          onChange={props.handleChange}
                          required=""
                        />
                      </div>
                    </div>
                  </div>
                ) : null}
              </fieldset>
            </li>
            <li>
              <fieldset class="radio radio-tab ml-3 mt-3">
                <legend style={{ marginTop: "-2.5rem" }}>
                  <Text id="step2.spousework" />*
                </legend>
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                    type="radio"
                    name="isSpouseWork"
                    id="c_q5_Y"
                    class="custom-control-input"
                    value="Y"
                    checked={data.isSpouseWork === "Y"}
                    onChange={props.handleChange}
                  />
                  <label for="c_q5_Y" class="radio-inline custom-control-label">
                    Yes
                  </label>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                    type="radio"
                    name="isSpouseWork"
                    id="c_q5_no"
                    class="custom-control-input"
                    value="N"
                    checked={data.isSpouseWork === "N"}
                    onChange={props.handleChange}
                  />
                  <label
                    for="c_q5_no"
                    class="radio-inline custom-control-label"
                  >
                    No
                  </label>
                </div>
              </fieldset>
            </li>
          </ol>
        </div>

        <h4 class="sub-heading">
          <strong>D. Please choose a Primary Care Physician (PCP)</strong>
        </h4>
        <div class="form-group ml-3">
          <p>
            Need to find a doctor? Visit
            <a
              href="sharpmedicareadvantage.com/findadoctor"
              target="_blank"
              rel="noopener noreferrer"
              style={{ marginLeft: "5px", marginRight: "5px" }}
            >
              <b> sharpmedicareadvantage.com/findadoctor</b>
            </a>
            to use our online search tool.
          </p>

          <PcpInputs handleChange={props.handleChange} data={props.data} />
          <div class="row">
            <div class="col-md-6">
              <fieldset class="radio radio-tab mt-3">
                <legend>Are you a current patient?</legend>
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                    type="radio"
                    name="isCurrentPatient"
                    id="currentPatient_Y"
                    class="custom-control-input"
                    value="Y"
                    checked={data.isCurrentPatient === "Y"}
                    onChange={props.handleChange}
                  />
                  <label
                    for="currentPatient_Y"
                    class="radio-inline custom-control-label"
                  >
                    Yes
                  </label>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                    type="radio"
                    name="isCurrentPatient"
                    id="currentPatient_no"
                    class="custom-control-input"
                    value="N"
                    checked={data.isCurrentPatient === "N"}
                    onChange={props.handleChange}
                  />
                  <label
                    for="currentPatient_no"
                    class="radio-inline custom-control-label"
                  >
                    No
                  </label>
                </div>
              </fieldset>
            </div>
          </div>
        </div>
        <h4 class="sub-heading">
          <strong>E. Language and format Preferences</strong>
        </h4>
        <div class="form-group">
          <fieldset class="radio radio-tab mt-3">
            <legend>
              Please check one of the boxes below if you would prefer us to send
              you information in a language other than English or in another
              format
            </legend>
            <div class="row">
              <div class="col-md-12">
                <React.Fragment>
                  <div class="custom-control custom-radio custom-control-inline mt-3">
                    <input
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                      type="radio"
                      name="prefLng"
                      id="lfp_spanish"
                      class="custom-control-input"
                      value="SPA"
                      checked={data?.prefLng === "SPA"}
                      onChange={props.handleChange}
                    />
                    <label
                      for="lfp_spanish"
                      class="radio-inline custom-control-label"
                    >
                      Spanish
                    </label>
                  </div>
                  <br />
                  <div class="custom-control custom-radio custom-control-inline mt-3">
                    <input
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                      type="radio"
                      name="accessibleFormatVal"
                      id="lfp_braille"
                      class="custom-control-input"
                      value="B"
                      checked={data?.accessibleFormatVal === "B"}
                      onChange={props.handleChange}
                    />
                    <label
                      for="lfp_braille"
                      class="radio-inline custom-control-label"
                    >
                      Braille
                    </label>
                  </div>
                  <br />
                  <div class="custom-control custom-radio custom-control-inline mt-3">
                    <input
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                      type="radio"
                      name="accessibleFormatVal"
                      id="lfp_largeprint"
                      class="custom-control-input"
                      value="L"
                      checked={data.accessibleFormatVal === "L"}
                      onChange={props.handleChange}
                    />
                    <label
                      for="lfp_largeprint"
                      class="radio-inline custom-control-label"
                    >
                      Large Print
                    </label>
                  </div>
                  <br />
                  <div class="custom-control custom-radio custom-control-inline mt-3">
                    <input
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                      type="radio"
                      name="accessibleFormatVal"
                      id="lfp_other"
                      class="custom-control-input"
                      value="OTHER"
                      checked={
                        data.accessibleFormatVal === "OTHER"
                        // ["",undefined].every((e1)=>e1!==document.getElementById("otherlanguageValue")?.value)
                      }
                      onChange={props.handleChange}
                    />
                    <label
                      for="lfp_other"
                      class="radio-inline custom-control-label"
                    >
                      Other
                    </label>
                  </div>
                  <br />
                </React.Fragment>

                <label for="otherlanguageValue" class="custom-control-inline mt-1">
                  <input
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                    type="text"
                    placeholder={
                      data.accessibleFormatVal === "OTHER"
                        ? "Please enter Other Language"
                        : ""
                    }
                    name="accessibleFormatOth"
                    id="otherlanguageValue"
                    maxlength="11"
                    class="form-control"
                    required=""
                    value={data.accessibleFormatOth}
                    onChange={props.handleChange}
                    disabled={
                      data.accessibleFormatVal === "" ||
                      data.accessibleFormatVal === "B" ||
                      data.accessibleFormatVal === "L"
                    }
                  />
                </label>
              </div>
            </div>
          </fieldset>
        </div>
        <div class="mt-3">
          <label class="control-label" for="fileUpload">
            <Text id="step4Agent.fileUpload" />
          </label>
          <div class="card">
            <div className="card-header file-upload-container-aligner display-inline-flex">
              <div class="select-file-typeSetp">
                <label
                  class="control-label select-filetype-label-setp"
                  for="fileType"
                >
                  <Text id="step4Agent.sfiletype" />
                </label>
                <select
                  name="fileType"
                  id="fileType"
                  class={"form-control"}
                  value={props.fileType}
                  onChange={props.handleChange}
                >
                  {props.typeOfFilesToUpload.map((item, i) => {
                    return (
                      <option class="select-option" value={item.value} key={i}>
                        {item.label}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className="file-upload-aligner file-upload-container">
                <label
                  className={
                    props.fileType === ""
                      ? "btn btn-secondary"
                      : "btn btn-primary"
                  }
                >
                  <input
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                    type="file"
                    name="fileUpload"
                    id="fileUpload"
                    class="display-none"
                    onChange={props.handleChange}
                    onClick={(event) => (event.target.value = "")}
                    disabled={props.fileType === "" ? true : false}
                  />
                  <i className="fa fa-upload" aria-hidden="true"></i>&nbsp;
                  <Text id="step4Agent.uploadFile" />
                </label>
              </div>
              {/* <div>
                    <button
                      className="btn btn-danger"
                      onClick={props.clearFiles}
                    >
                      <i className="fa fa-times" aria-hidden="true"></i>&nbsp;
                      <Text id="step4Agent.cancel" />
                    </button>
                  </div> */}
            </div>
            <div class="panel">
              <div class="card-body">
                {props.selectedFiles.map(
                  (file, index) =>
                    file.attachmentType !== "SIGNATURE" &&
                    file.attachmentType !== "ENROLLMENT" &&
                    file.attachmentType !== "SOA" && (
                      <div class="row">
                        <p class="col-md-3">
                          {file?.name || file?.attachmentType}
                        </p>
                        <a
                          href={props.url}
                          target="_blank"
                          class="col-md-5"
                          onClick={() =>
                            props.viewFile(
                              index,
                              file.name || file.attachmentName
                            )
                          }
                        >
                          {file?.File?.name || file?.attachmentName}
                        </a>
                        <p class="col-md-2">
                          {file && file.File
                            ? `${file.File.size / 1024} kb`
                            : ""}{" "}
                        </p>
                        <a
                          class="col-md-2 cursor-pointer"
                          onClick={() =>
                            props.removeFile(
                              index,
                              file.name || file.attachmentName
                            )
                          }
                        >
                          <i className="fa fa-times" aria-hidden="true"></i>
                        </a>
                      </div>
                    )
                )}
              </div>
            </div>
          </div>
        </div>
        <p>
          Please contact Sharp Health Plan at 1-855-562-8853 if you need
          information in an accessible format or language other than what is
          listed above. Our office hours are 8 a.m. to 8 p.m. 7 days per week
          from October 1 to March 31: 7 days per week 8 a.m. to 8 p.m. From
          April 1 to September 30: Monday through Friday, 8 a.m. to 8 p.m. and
          on weekends and holidays, your call will be handled by our voicemail
          system. A Customer Care Representative will return your phone call the
          next business day. TTY/TDD users should call 711.
        </p>
        <p>
          Sharp Health Plan provides the Evidence of Coverage, Formulary and
          Provider Directory online at &nbsp;
          <a
            href="sharpmedicareadvantage.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <b>sharpmedicareadvantage.com</b>
          </a>
          . Members can request a paper copy be mailed to them by calling
          Customer Care at the phone number listed above.
        </p>
        <p>
          <strong>NOTE:</strong> You may save and continue without completing
          all required fields (*); however, all required fields must be
          completed before submitting the enrollment form.
        </p>
        {props.preEnrollInfo?.appStatus != "READY" &&
          props.preEnrollInfo?.appStatus != "SUBMITTED" && (
            <button
              class="btn btn-saveNext"
              id="next2"
              onClick={props.redirect}
              style={{ backgroundColor: "#603167" }}
            >
              Save and Next
            </button>
          )}
        {/* </div>   */}
      </div>
      {/* </div> */}
    </React.Fragment>
  );
};
const mapStateToProps = (state) => {
  return {
    year: state.webApp.year?.planYear
      ? state.webApp.year.planYear
      : state.webApp.year,
    physiciansData: state.webApp.physiciansData,
    pcpSelected: state.webApp.selectedVo,
    preEnrollInfo: state.webApp.preEnrollInfo,
    stateId: state.webApp.stateId,
    planType: state.webApp.planType,
    product: state.webApp.product,
    deeplink: state.login.deeplink,
    customerId: state.login.customerId,
    agentLogin: state.login.agentLoggedIn,
    lang: state.webApp.language,
    productId: state.login.productId,
  };
};
const mapDispatchToProps = {
  getPcpList,
  setStateParams,
};
export default connect(mapStateToProps, mapDispatchToProps)(Step2);
